import { Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import actions from "../../actions";
import IconTimes from "../../../common/components/icons/IconTimes";

class BlockedPopup extends Component {
    constructor(props) {
        super(props);
    }

    render({ translate, showPermissionAlert, config }) {
        return (
            <div
                class="fxs_widget fxs_modal_wrap modal fxs_blockedNotificationsModal"
                tabindex="-1"
                role="dialog"
                aria-hidden="true"
            >
                <div class="fxs_modal_content">
                    <button
                        type="button"
                        onClick={() => showPermissionAlert(false)}
                        class="fxs_close_popupBlocked fxs_modal_close fxs_btn_icon close"
                        data-dismiss="modal"
                        aria-label="Close Modal"
                    >
                        <IconTimes />
                        <span class="fxs_skip">{translate("Close")}</span>
                    </button>
                    <div class="fxs_bg_light_5_clr fxs_HowTo">
                        <img
                            src="https://editorial.fxstreet.com/images/CalendarNotifications/onesignalsubscribe.png"
                        />
                    </div>
                    <div class="fxs_detail">
                        <h2 class="fxs_headline_from_small_to_medium">
                            {translate("BlockedPopup_Title")}
                        </h2>
                        <p class="fxs_entryPlain_txt">
                            {translate("BlockedPopup_Summary")}
                        </p>
                        <a
                            href={config.oneSignalDoc}
                            target="_blank"
                            class="fxs_fLeft fxs_mutedLink"
                        >
                            {translate("BlockedPopup_MoreInfo")}
                        </a>
                        <button
                            class="fxs_close_popupBlocked fxs_btn fxs_btn_cta fxs_fRight"
                            onClick={() => showPermissionAlert(false)}
                        >
                            {translate("Close")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connectWithTranslations("config", actions)(BlockedPopup);
